export { EditarPericiando } from './EditarPericiando'
